import ModusServiceModel from "../ModusServiceModel";
import ResultEventModel from "./ResultEventModel";
import DepthUnitModel from "./DepthUnitModel";
import ResultEventSampleCollection from "@/collections/modus/ResultEventSampleCollection";

export default class DepthReferenceModel extends ModusServiceModel {
  modelName() {
    return 'depth-references';
  }
  icon() {
    return 'ruler';
  }
  defaults() {
    return {
      id: null,
      result_event_id: null,
      result_event: null,
      depth_unit_id: null,
      depth_unit: null,
      identifier: null,
      depth_label: null,
      depth_column_depth: null,
      depth_start: null,
      depth_end: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_event_samples: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_event_id: (val) => (this.nullStringMutator(val)),
      depth_unit_id: (val) => (this.nullStringMutator(val)),
      identifier: (val) => (this.nullStringMutator(val)),
      depth_label: (val) => (this.nullStringMutator(val)),
      depth_column_depth: (val) => (this.nullStringMutator(val)),
      depth_start: (val) => (this.nullStringMutator(val)),
      depth_end: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getResultEvent() {
    return this.getRelatedModel(ResultEventModel, 'result_event');
  }
  getDepthUnit() {
    return this.getRelatedModel(DepthUnitModel, 'depth_unit');
  }
  getResultEventSamples() {
    return this.getRelatedCollection(new ResultEventSampleCollection(), 'result_event_samples');
  }
}
